<template>
  <div>
    <!-- <div class="container-fluid"> -->
      <div :class="{'notes_container' : !showList}">
        <!-- Note -->
        <div v-show="showList" class="mb-3">
          <div class="card">
            <transition-group name="fade" tag="div">
              <div v-for="n in notesList" class="card-block p-2 message" data-toggle="collapse" data-parent="#accordion" :href="'#collapse' + n['.key']" aria-expanded="true" :aria-controls="'#collapse' + n['.key']" :key="n['.key']">
                <div :id="'collapse' + n['.key']" class="collapse" role="tabpanel" aria-labelledby="headingOne">
                  <p class="text-justify">{{n.text}}</p>
                </div>
                <p class="header font-grey">
                  <i>{{n.name}}</i>
                  <i class="pull-right">{{ getDate(n.date)}}</i>
                </p>
              </div>
            </transition-group>
          </div>
        </div>

        <!-- Create note -->
        <div v-show="isAllowCreateNote" style="flex-grow: 1">
          <h3 v-show="title" for="note-message" class="kne-title">{{ title }}</h3>
          <label v-show="label" for="note-message" class="mb-0">{{ label }}<strong class="red_text">*</strong></label>
          <regular-input
            v-if="regularInput"
            id="note-message"
            :value="note.text"
            @input="note.text = $event"
            :placeholder="placeholder"
            rows="1"
          />
          <regular-textarea
            v-if="!regularInput"
            id="note-message"
            :value="note.text"
            @input="note.text = $event"
            :placeholder="placeholder"
            rows="1"
          />
          <button
            v-show="showCreateNoteButton"
            class="btn btn-kne-orange mt-2 w-100"
            :disabled="!isNoteFilled"
            @click="onSaveNote(orderId)">
            {{$t('CreateNote.create_note_button')}}
          </button>
        </div>

      </div>
    <!-- </div> -->
  </div>
</template>

<script>
import { db, dbArchives2 } from '../../../../firebase'

import regularInput from '../../basic-components/regularInput.vue'
import RegularTextarea from '../../basic-components/regularTextarea.vue'
export default {
  name: 'CreateNote',

  components: {
    regularInput,
    RegularTextarea
  },

  props: {
    title: String,
    label: String,
    notesList: Array,
    showList: Boolean,
    showCreateNoteButton: Boolean,
    arrOfOrders: Array,
    orderId: String,
    isAllowCreateNote: {
      type: Boolean,
      required: true
    },
    regularInput: {
      type: Boolean,
      required: false,
      default: false
    },
    placeholder: {
      type: String,
      required: false
    }
  },

  data () {
    return {
      paginate: ['notesList'],
      note: {
        text: '',
        date: '',
        name: ''
      }
    }
  },

  async created () {
    await this.$bindAsObject('user', db.ref(`userInfos/${this.companyUID}/${this.uid}`))
  },

  methods: {
    async onSaveNote (orderId) {
      if (!this.isNoteFilled) return false
      const dbPath = this.setDbPath(orderId)
      this.pushFirebase(dbPath)

      this.emitNoteFilled() // Because this is a component, some other components need to know if the note is filled
      this.clearNoteText()

      return true // For validation reason validation in StatusChange-modal
    },

    /** Return DB path for Firebase */
    setDbPath (orderId) {
      const id = this.companyUID
      let dbPath = ''

      if (this.$route.query.archive && this.$route.query.archivedOrder) dbPath = dbArchives2.ref('database/transporter/' + id + '/deliveries/' + orderId + '/notes/') // These options are required for OrderInfo
      else if (!this.$route.query.archive && this.$route.query.archivedOrder) dbPath = dbArchives2.ref('database/transporter/' + id + '/deliveries/' + orderId + '/notes/') // These options are required for OrderInfo
      else dbPath = db.ref('database/transporter/' + id + '/deliveries/' + orderId + '/notes/')

      return dbPath
    },

    async pushFirebase (dbPath) {
      this.setNoteInfo(Date.now(), this.user)

      await dbPath.push(this.note).then(() => {
      }).catch(function (error) {
        console.log(error)
      })
    },

    setNoteInfo (date, userInfo) {
      this.setNoteDate(date)
      this.setNoteName(userInfo)
    },

    setNoteDate (date) {
      this.note.date = date
    },

    /** Some accounts don't have a @param firstName and @param lastName */
    setNoteName (user) {
      const isFirstNameValid = (typeof user.firstName !== 'undefined' && user.firstName !== '')
      const isLastNameValid = (typeof user.lastName !== 'undefined' && user.lastName !== '')

      if (!isFirstNameValid || !isLastNameValid) this.note.name = this.$store.state.userInfo.name
      else this.note.name = `${user.firstName} ${user.lastName}`
    },

    clearNoteText () {
      this.note.text = ''
    },

    /** Send to parent component @emits OrderInfo.vue */
    emitNoteFilled () {
      this.$emit('noteCreated')
    },

    getDate: function (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },

    getNoteText () {
      return this.note.text
    }
  },
  computed: {
    isNoteFilled () {
      return (this.note.text !== '')
    },

    companyUID () {
      return this.$store.state.authorization.company
    },

    uid () {
      return this.$store.state.user.uid
    }
  },

  watch: {
    notes: function (snapshot) {
      if (snapshot) {
        this.notesList = JSON.parse(JSON.stringify(snapshot))
        this.notesList.reverse()
      }
    }
  }
}
</script>

<style scoped>
.notes_container {
  display: flex;
  justify-content: space-around;
}
</style>
